module.exports = __webpack_public_path__ + "9c62abc1c2ec6e80191bb7a3375775c1.jpg";